import LegalLayout, { LegalSection } from "./LegalLayout";

export default function Disclaimer() {
  return (
    <LegalLayout label="DISCLAIMER" title="Earnings &amp; Results Disclaimer" effective="December 2026">
      <p>
        The information, testimonials, and case studies presented on
        smallbusinessautomator.com (the &ldquo;Site&rdquo;) are provided for
        educational and informational purposes only. Please read the following
        carefully.
      </p>

      <LegalSection heading="No Guarantee of Results">
        <p>
          Any income, lead-generation, application, appointment, or business
          results mentioned on this Site — including numbers in case studies or
          testimonials — reflect specific individual outcomes and are not
          typical. Your results will vary based on your market, offer, effort,
          business situation, and countless other factors we cannot control or
          predict. Nothing on the Site is a promise, guarantee, or warranty of
          any specific outcome.
        </p>
      </LegalSection>

      <LegalSection heading="Testimonials">
        <p>
          Testimonials shown on the Site come from actual clients who have used
          our programs. They represent individual experiences and are not
          representative of what every client will experience.
        </p>
      </LegalSection>

      <LegalSection heading="Not Financial, Legal, Tax, or Mortgage Advice">
        <p>
          Content on the Site is not financial, legal, tax, accounting,
          investment, or mortgage advice. Small Business Automator does not
          originate loans and is not a licensed mortgage originator, broker, or
          investment adviser. Consult a qualified professional before making
          business, financial, tax, legal, or mortgage decisions.
        </p>
      </LegalSection>

      <LegalSection heading="Compliance With Applicable Regulations">
        <p>
          If you are a licensed mortgage professional or in another regulated
          industry, you are solely responsible for complying with all federal,
          state, and local laws and regulations that apply to your marketing,
          advertising, communications, and business practices — including but
          not limited to RESPA, TCPA, TILA, ECOA, state licensing rules, and
          your broker&rsquo;s policies. Nothing on this Site or in any SBA
          program relieves you of that responsibility.
        </p>
      </LegalSection>

      <LegalSection heading="Third-Party Trademarks">
        <p>
          Any third-party trademarks referenced on the Site are the property of
          their respective owners. Reference does not imply endorsement.
        </p>
      </LegalSection>

      <LegalSection heading="Forward-Looking Statements">
        <p>
          Statements about future results, projections, or expectations are
          forward-looking and subject to risks and uncertainties. Actual outcomes
          may differ materially.
        </p>
      </LegalSection>

      <LegalSection heading="Questions">
        <p>
          For questions about this Disclaimer, email <a href="mailto:dallas@smallbusinessautomator.com" className="text-[#C9A84C] hover:underline">dallas@smallbusinessautomator.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
